import type { FaireProductEntity } from "../../entity_types/product";

export const p_kzt6surh3c: FaireProductEntity = {
  token: "p_kzt6surh3c",
  type: "product",
  name: "Flower Bath Bomb",
  brandToken: "b_kbwwwxjxec",
  brandName: "Jasmine’s Essence",
  imageUrl:
    "https://cdn.faire.com/fastly/f2e747cb9adbebd2912c01390db4227422b45f53a8f364970f1f2111a4d950a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de3163b965d0a2f658cdaa8b7126318ee8e815e7a0a4e737564eb26c9cd67f22.jpeg",
    "https://cdn.faire.com/fastly/ad6dedf2c52a13ac8da5f913c31b3b197cc7756a2c12d74e6822c016c8fc3d5b.jpeg",
    "https://cdn.faire.com/fastly/c800baef30f743b9bbbca75ba4ffa53e04d1fc238cda1c4daab945a08893815e.jpeg",
    "https://cdn.faire.com/fastly/e66d7fa0bdbd7999ad5cbf456481ff517d3e1a967f1834ed6825774afb370828.jpeg",
    "https://cdn.faire.com/fastly/1f2cfb715324ad2889db4e9901465139e499f3afa37069e6813bb117dd19a424.jpeg",
    "https://cdn.faire.com/fastly/8def155afa1b9091f0178503f246c7d190fe28770e4b88a47815a140c49a11c5.jpeg",
    "https://cdn.faire.com/fastly/6b727478e36f660285031811e692fa68f3fb16f73243f5eec583c6bdea013bf2.jpeg",
  ],
  priceDollars: 3,
  description:
    "Bring a touch of botanical beauty to your self‑care ritual with our handcrafted Flower Bath Bombs. These specialty floral‑shaped fizzers are made in small batches using gentle, all‑natural ingredients that soften the water, nourish the skin, and fill your bath with luxurious fragrance.\n\nPerfect for gifting, pampering, and celebrating life’s sweetest moments — including your own.\n\n\n\nWhy You’ll Love Them\n\n• Specialty flower‑shaped design\n\n• Handcrafted in small batches\n\n• All‑natural, sensitive‑skin‑friendly ingredients\n\n• Rich, creamy fizz\n\n• Beautiful colors that won’t stain your tub\n\n• Perfect for gifting, pampering, and special occasions\n\n• Available in all your favorite Jasmine’s Essence scents\n\n\n\nScent Descriptions\n\nLavender Lullaby— Lavender & Chamomile\n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:17.467Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
